/* tslint:disable */
export var icon = "\n<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"46\" height=\"70\"><path fill=\"currentColor\" d=\"M30.707 39.293a1 1 0 01-1.414 1.414l-5-5a1 1 0 010-1.414l5-5a1 1 0 111.414 1.414L26.414 35l4.293 4.293z\"/></svg>\n";
//# sourceMappingURL=back-arrow-small.svg.js.map